// extracted by mini-css-extract-plugin
module.exports = {"widgetDrawer":"WidgetDrawer_widgetDrawer__1xjQk","header":"WidgetDrawer_header__2O3TO","content":"WidgetDrawer_content__yJ7AW","title":"WidgetDrawer_title__12IeA"};